import React from 'react';
import './styles/Alert.css';

interface AlertProps {
  isOpen: boolean;
  title: string;
  message: string;
  onConfirm?: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
}

const Alert: React.FC<AlertProps> = ({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = '',
  cancelText = 'Cancel',
}) => {
  if (!isOpen) return null;

  return (
    <div className="alert-overlay">
      <div className="alert-modal">
        <div className="alert-header">
          <h3 className="alert-title">{title}</h3>
        </div>
        <div className="alert-body">
          <p className="alert-message">{message}</p>
        </div>
        <div className="alert-footer">
          <button className="alert-btn alert-btn-cancel" onClick={onCancel}>
            {cancelText}
          </button>
          {confirmText && (
            <button className="alert-btn alert-btn-confirm" onClick={onConfirm}>
              {confirmText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Alert;
